import { Select, SelectProps } from 'antd';
import toLowerCase from 'utils/toLowerCase';
import useStoreRegionOptions from '../hooks/useStoreRegionOptions';
import { useTranslate } from '@tolgee/react';

export default function RegionSelect(props: SelectProps<General.UpperCaseRegion[]>) {
  const { t } = useTranslate();

  const { regions, loading } = useStoreRegionOptions();

  const options = regions.map((region) => ({
    value: region,
    label: t(`region.${toLowerCase(region)}`),
  }));

  return (
    <Select
      dropdownMatchSelectWidth={false}
      mode="multiple"
      maxTagCount="responsive"
      loading={loading}
      options={options}
      placeholder={t('请选择')}
      style={{ width: '100%' }}
      {...props}
    />
  );
}
